// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-046bed1e]:export {\n  theme: #30B08F;\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.activityList .store_content[data-v-046bed1e] {\n  margin-bottom: 20px;\n}\n.activityList .store_content span[data-v-046bed1e] {\n  margin-right: 20px;\n  color: red;\n}", ""]);
// Exports
module.exports = exports;
